import HomeHero from './HomeHero'

export default HomeHero